@if (petData) {
  <div class="info-block pet-info">
    <div class="header">
      <div class="title">
        <p class="tag-12">{{ 'insurance-overview.pet-info-header' | translate }}</p>
      </div>
      @if (desktopVersion) {
        <div class="actions">
          <button class="button white text-button-small" (click)="editPetInfo()">
            <span class="button-text">{{ 'insurance-overview.edit-pet-info' | translate }}</span>
          </button>
        </div>
      }
    </div>
    <div class="rows-container split-equally">
      <div class="rows">
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.pet-name' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.pet_name }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.pet-species' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.pet_species | specieTranslate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.pet-gender' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.pet_gender | genderTranslate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.breed' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ getBreed() | translate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.date-of-birth' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.birthdate | date: 'dd.MM.yyyy' }}</p>
          </div>
        </div>
        @if (petData.pet_species === 'cat') {
          <div class="row">
            <div class="title">
              <p class="body-14">{{ 'insurance-overview.housecat' | translate }}</p>
            </div>
            <div class="value">
              <p class="subtitle-14">{{ petData.housecat | booleanTranslate }}</p>
            </div>
          </div>
        }
        @if (!desktopVersion) {
          <div class="row">
            <div class="title">
              <p class="body-14">{{ 'insurance-overview.neutered' | translate }}</p>
            </div>
            <div class="value">
              <p class="subtitle-14">{{ petData.neutered | booleanTranslate }}</p>
            </div>
          </div>
        }
      </div>
      @if (!desktopVersion) {
        <div class="actions">
          <button class="button white text-button-small" (click)="editPetInfo()">
            <span class="button-text">{{ 'insurance-overview.edit-pet-info' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
  <div class="info-block insurance-info">
    <div class="header">
      <div class="title">
        <p class="tag-12">{{ 'insurance-overview.insurance-info-header' | translate }}</p>
      </div>
      @if (desktopVersion) {
        <div class="actions">
          <button class="button white text-button-small" (click)="openDetails()">
            <span class="button-text">{{ 'insurance-overview.edit-insurance-info' | translate }}</span>
          </button>
        </div>
      }
    </div>
    <div class="rows-container split-equally">
      <div class="rows">
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.contract-number' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.full_contract_number.split('-')[0] }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.coverage-level' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ getBundleName() | translate }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.overall-price' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14 no-capitalize">CHF {{ getTotalPrice() | number:'1.2-2' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.insurance-date' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.start_date | date:'dd.MM.yyyy' }} @if (!isContractActive) {
              - {{ petData.end_date | date:'dd.MM.yyyy' }}
            }</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.overall-sum-insured' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.overall_sum_insured | currency:'CHF':'symbol':'1.0-0' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.annual-franchise' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ petData.annual_franchise  | currency:'CHF':'symbol':'1.0-0' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-14">{{ 'insurance-overview.deductible' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-14">{{ showCurrentDeductible() }}%</p>
          </div>
        </div>
      </div>
      @if (!desktopVersion) {
        <div class="actions">
          <button class="button white text-button-small" (click)="openDetails()">
            <span class="button-text">{{ 'insurance-overview.edit-insurance-info' | translate }}</span>
          </button>
        </div>
      }
    </div>
  </div>
}
